const streetBaseMapStyle = "mapbox://styles/mapbox/dark-v10";
const satelliteBaseMapStyle = "mapbox://styles/mapbox/satellite-streets-v11";
export { streetBaseMapStyle, satelliteBaseMapStyle };
